import { logger } from '@lusha/client-logger';
import isEmpty from 'lodash.isempty';
import { applySnapshot, flow, getRoot, getSnapshot } from 'mobx-state-tree';
import { searchCompaniesByName } from '../../../API/prospectingAPI';
import { formatFundingSummary } from '../FundingSummary/utils';
import { getRevenueRangeString } from './utils';
const Actions = self => {
    let initialState;
    const resetState = () => {
        applySnapshot(self, initialState);
    };
    return {
        afterCreate: () => {
            initialState = getSnapshot(self);
        },
        setCompany: company => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (isEmpty(company)) {
                resetState();
                return;
            }
            const { name = '', logo_url = '', domains: { homepage = '' } = {}, homepage_url = '', location: { city, region, country = '', country_iso2 = '', state = '' } = {}, company_size: { min, max } = {}, description = '', founded, industry_tags = [], social: { facebook, twitter, LinkedIn, linkedin } = {
                facebook: '',
                twitter: '',
                LinkedIn: '',
                linkedin: '',
            }, revenue_range, company_lid: companyLid = null, company_lids: companyLids, isBlockedForShow, topics = [], funding_summary: fundingSummary = null, industry = {}, specialities, metadata, } = company;
            const { primary_industry: primaryIndustry = {} } = industry;
            self.hasCompany = true;
            self.isSocial = !!company.social;
            self.name = name || '';
            self.logoUrl = logo_url || '';
            self.domain = homepage || 'Company Website';
            self.homepageUrl = homepage_url || '';
            self.city = city || '';
            self.region = region || '';
            self.country = country || '';
            self.country_iso2 = country_iso2;
            self.state = state;
            self.min = min || 0;
            self.max = max || 0;
            self.about = description || '';
            self.founded = founded || '';
            self.specialities = specialities || industry_tags || [];
            self.mainIndustry = ((_a = industry === null || industry === void 0 ? void 0 : industry.primary_industry) === null || _a === void 0 ? void 0 : _a.key) || '';
            self.mainIndustryKey = primaryIndustry.key || '';
            self.subIndustry = ((_b = primaryIndustry === null || primaryIndustry === void 0 ? void 0 : primaryIndustry.sub_industry) === null || _b === void 0 ? void 0 : _b.key) || '';
            self.facebook = facebook || '';
            self.twitter = twitter || '';
            self.LinkedIn = LinkedIn || linkedin || '';
            self.companyResultString = JSON.stringify(company);
            self.revenueRange = revenue_range ? Object.assign(Object.assign({}, revenue_range), { string: getRevenueRangeString(revenue_range) }) : {};
            self.companyLid = companyLid;
            self.companyLids = companyLids;
            self.isBlockedForShow = isBlockedForShow || false;
            self.lushaCompanyId = company.lusha_company_id;
            if (self.topics.length === 0) {
                self.topics = topics;
            }
            self.fundingSummary = formatFundingSummary(fundingSummary);
            self.mainIndustryId = (_c = industry === null || industry === void 0 ? void 0 : industry.primary_industry) === null || _c === void 0 ? void 0 : _c.id;
            if (metadata) {
                self.metadata = {
                    hasProspectingContacts: (_d = metadata.has_prospecting_contacts) !== null && _d !== void 0 ? _d : null,
                    hasProspectingContactsCount: (_e = metadata.has_prospecting_contacts_count) !== null && _e !== void 0 ? _e : null,
                    companyScore: (_f = metadata.company_score) !== null && _f !== void 0 ? _f : null,
                    partialCompany: (_g = metadata.partial_company) !== null && _g !== void 0 ? _g : null,
                };
            }
        },
        setListId(listId) {
            self.listId = listId;
        },
        setCompanyLid(companyLid) {
            self.companyLid = companyLid;
        },
        fetchCompanyLid: flow(function* fetchCompanyLid() {
            var _a;
            const { context } = getRoot(self);
            try {
                const response = yield searchCompaniesByName({
                    company: self.name,
                    platform: 'Scout',
                    url: context.url,
                });
                if ((_a = response.companies) === null || _a === void 0 ? void 0 : _a.length) {
                    const searchedCompany = response.companies[0];
                    const companyLid = searchedCompany.company_lid;
                    self.setCompanyLid(companyLid);
                }
            }
            catch (error) {
                logger.info('Failed to fetch company lid: ', error);
            }
        }),
        setPartial: company => {
            self.name = company.name || '';
            self.domain = company.domain || '';
            self.logoUrl = company.logoUrl || '';
        },
    };
};
export default Actions;
